/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface GetProfileAccessRights$Request {
    profileId: number;
}

export interface GetProfileAccessRights$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProfileAccessRightsRequest = createAction<PayloadData<void, GetProfileAccessRights$Request>>('GET_PROFILE_ACCESS_RIGHTS__GET_PROFILE_ACCESS_RIGHTS__REQUEST');
export const getProfileAccessRightsSuccess = createAction<PayloadData<Array<string>, GetProfileAccessRights$Request>>('GET_PROFILE_ACCESS_RIGHTS__GET_PROFILE_ACCESS_RIGHTS__SUCCESS');
export const getProfileAccessRightsFailure = createAction<PayloadData<Error, GetProfileAccessRights$Request, true>>('GET_PROFILE_ACCESS_RIGHTS__GET_PROFILE_ACCESS_RIGHTS__FAILURE');

export const getProfileAccessRightsActions = [
    getProfileAccessRightsRequest,
    getProfileAccessRightsSuccess,
    getProfileAccessRightsFailure
] as const;

/**
 * @param {number} meta.profileId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProfileAccessRights = (meta: GetProfileAccessRights$Request, config?: GetProfileAccessRights$Config) => {
    return {
        CALL_API: {
            types: getProfileAccessRightsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/admins/profiles/${meta.profileId}/access-rights`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

